// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__203kJ","subheader":"ReorderModal_subheader__3ttTO","listWrap":"ReorderModal_listWrap__1Yu5F"};